import {
  BsArrowCounterclockwise,
  BsArrowRepeat,
  BsArrowUpRight,
  BsBank,
  BsBell,
  BsBoxArrowRight,
  BsCalendar,
  BsChatDots,
  BsCheck,
  BsCheckCircle,
  BsChevronDown,
  BsChevronLeft,
  BsChevronRight,
  BsDownload,
  BsDropletFill,
  BsEnvelope,
  BsEye,
  BsEyeSlash,
  BsFileEarmark,
  BsFileEarmarkArrowDown,
  BsFileEarmarkText,
  BsFillPersonFill,
  BsGear,
  BsGeo,
  BsHourglass,
  BsImage,
  BsLayoutSidebarReverse,
  BsLayoutSplit,
  BsLayoutThreeColumns,
  BsLink45Deg,
  BsList,
  BsMap,
  BsPencil,
  BsPencilSquare,
  BsPeopleFill,
  BsPlus,
  BsPlusCircleFill,
  BsSearch,
  BsSlashCircle,
  BsSortDown,
  BsSortDownAlt,
  BsTextCenter,
  BsThreeDotsVertical,
  BsTrash,
  BsTypeBold,
  BsTypeItalic,
  BsTypeUnderline,
  BsWrench,
  BsX,
} from 'react-icons/bs';

import { IconContext } from 'react-icons';
import { IconBaseProps } from 'react-icons/lib/cjs/iconBase';

export type IconType =
  | 'add-new'
  | 'bold'
  | 'bank'
  | 'calendar'
  | 'check-circle'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'download'
  | 'draggable'
  | 'edit'
  | 'external-link'
  | 'eye'
  | 'eye-open'
  | 'eye-slash'
  | 'file'
  | 'file-download'
  | 'image'
  | 'italic'
  | 'link'
  | 'list'
  | 'logo'
  | 'logout'
  | 'mail'
  | 'person'
  | 'people'
  | 'plus'
  | 'plus-circle'
  | 'repeat'
  | 'save'
  | 'search'
  | 'settings'
  | 'slash-circle'
  | 'text-center'
  | 'trash'
  | 'three-columns'
  | 'underline'
  | 'undo'
  | 'wrench'
  | 'x'
  | 'hour-glass'
  | 'geo'
  | 'bell'
  | 'chat-dots'
  | 'check'
  | 'right-pane'
  | 'split-pane'
  | 'map'
  | 'sort-asc'
  | 'sort-desc';

export type IconProps = IconContext &
  IconBaseProps & {
    icon: IconType;
  };

export const iconArray: IconType[] = [
  'add-new',
  'bold',
  'bank',
  'calendar',
  'check-circle',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'download',
  'draggable',
  'edit',
  'external-link',
  'file',
  'file-download',
  'image',
  'italic',
  'link',
  'list',
  'logo',
  'logout',
  'mail',
  'person',
  'people',
  'plus',
  'plus-circle',
  'repeat',
  'save',
  'search',
  'settings',
  'slash-circle',
  'text-center',
  'three-columns',
  'trash',
  'underline',
  'undo',
  'wrench',
  'x',
  'hour-glass',
  'geo',
  'bell',
  'chat-dots',
  'check',
  'right-pane',
  'split-pane',
  'map',
  'sort-asc',
  'sort-desc',
];

const Icon = (props: IconProps): JSX.Element => {
  // Get the icon prop
  const { icon } = props;

  switch (icon) {
    case 'bank':
      return BsBank(props);
    case 'person':
      return BsFillPersonFill(props);
    case 'people':
      return BsPeopleFill(props);
    case 'logo':
      return BsDropletFill(props);
    case 'logout':
      return BsBoxArrowRight(props);
    case 'edit':
      return BsPencil(props);
    case 'file':
      return BsFileEarmarkText(props);
    case 'file-download':
      return BsFileEarmarkArrowDown(props);
    case 'image':
      return BsImage(props);
    case 'list':
      return BsList(props);
    case 'search':
      return BsSearch(props);
    case 'chevron-left':
      return BsChevronLeft(props);
    case 'chevron-right':
      return BsChevronRight(props);
    case 'chevron-down':
      return BsChevronDown(props);
    case 'calendar':
      return BsCalendar(props);
    case 'repeat':
      return BsArrowRepeat(props);
    case 'mail':
      return BsEnvelope(props);
    case 'download':
      return BsDownload(props);
    case 'three-columns':
      return BsLayoutThreeColumns(props);
    case 'slash-circle':
      return BsSlashCircle(props);
    case 'check-circle':
      return BsCheckCircle(props);
    case 'save':
      return BsFileEarmark(props);
    case 'settings':
      return BsGear(props);
    case 'x':
      return BsX(props);
    case 'link':
      return BsArrowUpRight(props);
    case 'add-new':
      return BsPencilSquare(props);
    case 'bold':
      return BsTypeBold(props);
    case 'italic':
      return BsTypeItalic(props);
    case 'underline':
      return BsTypeUnderline(props);
    case 'undo':
      return BsArrowCounterclockwise(props);
    case 'text-center':
      return BsTextCenter(props);
    case 'trash':
      return BsTrash(props);
    case 'external-link':
      return BsLink45Deg(props);
    case 'draggable':
      return BsThreeDotsVertical(props);
    case 'plus-circle':
      return BsPlusCircleFill(props);
    case 'eye-open':
    case 'eye':
      return BsEye(props);
    case 'eye-slash':
      return BsEyeSlash(props);
    case 'wrench':
      return BsWrench(props);
    case 'hour-glass':
      return BsHourglass(props);
    case 'geo':
      return BsGeo(props);
    case 'bell':
      return BsBell(props);
    case 'chat-dots':
      return BsChatDots(props);
    case 'check':
      return BsCheck(props);
    case 'split-pane':
      return BsLayoutSplit(props);
    case 'right-pane':
      return BsLayoutSidebarReverse(props);
    case 'map':
      return BsMap(props);
    case 'sort-asc':
      return BsSortDownAlt(props);
    case 'sort-desc':
      return BsSortDown(props);

    case 'plus':
    default:
      return BsPlus(props);
  }
};

export default Icon;

//
// Use these
// 'repeat' / status
// 'x' / rejected
// 'check-circle' |// pass

// add: check, messsage
